/**
 * Gestione Sottoscrizioni
 *
 * Contact: bonjoprg@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SubscriptionListItemDto { 
    id: number;
    nomeCompleto: string;
    telefono: string;
    importo: string;
    modalitaPagamento: SubscriptionListItemDtoModalitaPagamentoEnum;
}
export enum SubscriptionListItemDtoModalitaPagamentoEnum {
    Contanti = 'CONTANTI',
    Bonifico = 'BONIFICO',
    Pos = 'POS',
    Rid = 'RID'
};



